import BaseService from './Base';

export default class ChatCanalService extends BaseService {
  static endpoint = 'api/2.0/stream-chat/';
}